import React, { useEffect } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { Table } from "react-bootstrap";
import { CategoryActions } from "../../redux";
import BasicPagination from "../../../pagination/BasicPagination";
import { useHistory } from "react-router-dom";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import { getAllCategoryAsync, deleteCategoryAsync } from "../../redux";
import { useIsAccessAllow } from "../../../users/redux";

const Bdc_tagCategoryTable = () => {
  const history = useHistory();
  const {
    isLoading,
    categoryList,
    skip,
    limit,
    searchBy,
    searchText,
  } = useSelector((state) => state.category, shallowEqual);

  useEffect(() => {
    dispatch(getAllCategoryAsync(searchBy, searchText));
    // eslint-disable-next-line
  }, []);

  const dispatch = useDispatch();
  const onPageChange = (currentBatch) => {
    let count = currentBatch ? currentBatch - 1 : skip;
    dispatch(CategoryActions.setCategoryBatchNumber(count));
  };

  const onEditClick = (data) => {
    history.push(`/bdc_category/edit-category/${data?._id}`);
  };
  const onDeleteClick = (data) => {
    if (window.confirm("Are you sure you want to delete?")) {
      dispatch(deleteCategoryAsync(data?._id));
      dispatch(getAllCategoryAsync(searchBy, searchText));
    }
  };
  const isEditCategoryAllow = useIsAccessAllow("bdc_category.edit_category");
  const isDeleteAllow = useIsAccessAllow("bdc_category.delete_category");

  return (
    <div className="px-6 pt-0 dash_wt_bx pb-0 ovflhddn loader-display-position">
      <div className="tblmrgn mt-0">
        <div className="mt-5">
          <div>
            <Table
              hover
              responsive
              className="mb-0 default_table with_hoverbtn mrpdng_tbl"
            >
              <thead>
                <tr>
                  <th>Sr No.</th>
                  <th>Slug</th>
                  <th>Title</th>
                  <th>Created On</th>
                  <th>Display Website</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {categoryList.records && categoryList.records.length ? (
                  categoryList.records.map((categoryLists, index) => (
                    <tr key={index}>
                      <td>
                        <span>{skip * limit + (index + 1)}</span>
                      </td>
                      <td>
                        <span>{categoryLists.slug}</span>
                      </td>
                      <td>
                        <span>
                          <span>{categoryLists.title}</span>
                        </span>
                      </td>

                      <td>
                        <span>
                          {new Date(categoryLists.createdOn).toLocaleString()}
                        </span>
                      </td>
                      <td>
                        <span>
                          <span>{categoryLists.display_num}</span>
                        </span>
                      </td>
                      <td>
                        {isEditCategoryAllow && (
                          <button
                            title="Edit"
                            className="btn btn-icon btn-light btn-hover-primary btn-sm mr-3"
                            onClick={() => onEditClick(categoryLists)}
                          >
                            <span className="svg-icon svg-icon-md svg-icon-primary">
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/icons/Communication/Write.svg"
                                )}
                              />
                            </span>
                          </button>
                        )}

                        {isDeleteAllow && (
                          <button
                            title="Delete"
                            className="btn btn-icon btn-light btn-hover-danger btn-sm"
                            onClick={() => onDeleteClick(categoryLists)}
                          >
                            <span className="svg-icon svg-icon-md svg-icon-danger">
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/icons/General/Trash.svg"
                                )}
                              />
                            </span>
                          </button>
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={8} className="text-center">
                      No Record Found
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
          {!isLoading && (
            <div className="row d-flex align-items-center mr-5 ml-5 mt-4">
              <div className="col-md-8 text-right mb-5 aspgntn">
                <BasicPagination
                  totalRecords={categoryList.recordsTotal}
                  limit={limit}
                  batch={skip + 1}
                  onBatchChange={onPageChange}
                />
              </div>
              <div className="col-md-4 mb-5 fn_s_16 f-w-400 text-right">
                Displaying {skip * limit + 1} - {skip * limit + limit} of{" "}
                {categoryList.recordsTotal} Records
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Bdc_tagCategoryTable;
